import { render } from "./PortfolioLinks.vue?vue&type=template&id=c4162dee&scoped=true"
import script from "./PortfolioLinks.vue?vue&type=script&lang=js"
export * from "./PortfolioLinks.vue?vue&type=script&lang=js"

import "./PortfolioLinks.vue?vue&type=style&index=0&id=c4162dee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c4162dee"

export default script